import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import oticonIntent from '../images/horapparater/Oticon_Intent_miniRITE_H1-2024_Left_C090ChromaBeige_LEDgreen_Speaker60_OpenBassDome_1200x1200px_Original file.webp';

const Services: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold text-[#0A4A7A] mb-12">{t('services.title')}</h1>
        
        <section id="horapparater" className="mb-16">
          <div className="bg-gray-50 rounded-lg p-8">
            <p className="text-gray-700 mb-6">{t('services.horapparaterDesc')}</p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-start">
              <div>
                <h3 className="text-xl font-semibold mb-4 text-[#0A4A7A]">{t('services.ourServices')}</h3>
                <ul className="list-disc list-inside text-gray-700 space-y-2">
                  <li>{t('services.horseltest')}</li>
                  <li>{t('services.anpassning')}</li>
                  <li>{t('services.provperiod')}</li>
                  <li>{t('services.uppfoljning')}</li>
                  <li>{t('services.rengoring')}</li>
                  <li>{t('services.garanti')}</li>
                </ul>
              </div>
              <div>
                <Link
                  to="/horapparater"
                  className="group flex flex-col bg-white rounded-lg overflow-hidden border border-gray-200 shadow-sm hover:shadow-xl hover:border-[#0A4A7A] transition-all duration-300 max-w-sm"
                >
                  <div className="h-40 bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center overflow-hidden">
                    <img
                      src={oticonIntent}
                      alt={t('services.horapparatModeller') as string}
                      className="max-h-full max-w-full object-contain p-4 group-hover:scale-105 transition-transform duration-300"
                    />
                  </div>
                  <div className="px-5 py-4 bg-[#0A4A7A] text-white">
                    <h3 className="text-lg font-semibold">{t('services.horapparatModeller')}</h3>
                    <p className="mt-1 text-sm text-white/90 group-hover:translate-x-1 transition-transform duration-300">
                      {t('services.horapparatModellerDesc')}
                    </p>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </section>

        <div className="text-center bg-[#0A4A7A] rounded-lg p-8">
          <h3 className="text-2xl font-semibold mb-4 text-white">{t('services.bookTitle')}</h3>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="tel:072-334 47 74" className="bg-white text-[#0A4A7A] px-6 py-3 rounded font-semibold hover:bg-gray-100 transition-colors">
              {t('services.call')} 072-334 47 74
            </a>
            <a href="https://www.bokadirekt.se/places/varmdo-horsel-134414" target="_blank" rel="noopener noreferrer" className="border border-white text-white px-6 py-3 rounded font-semibold hover:bg-white/10 transition-colors">
              {t('services.bookTime')}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
